import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Scoping",
description: "Learn how Freon implements declarative scoping based on scope graph theory, how to define scoping rules in Freon’s meta-language, and how to generate the scoper.",
tags: [ "scoping", "scope graphs", "scope provider", "static semantics", "dynamic semantics", "scoper generator", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:20:18.610Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};